var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7926 14.7273H1.19815C0.539168 14.7273 0 14.1881 0 13.5291V10.1843C0 9.86478 0.119815 9.56524 0.349461 9.33559L9.33559 0.349461C9.56524 0.119815 9.86478 0 10.1843 0C10.5038 0 10.8033 0.119815 11.033 0.349461L14.3778 3.6943C14.8471 4.16357 14.8471 4.9224 14.3778 5.39168L5.21196 14.5575C5.10213 14.6674 4.95236 14.7273 4.7926 14.7273ZM10.1843 1.19815L1.19815 10.1843V13.5291H4.54299L13.5291 4.54299L10.1843 1.19815Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9819 7.53755C11.8321 7.53755 11.6724 7.47764 11.5625 7.35782L7.36901 3.1643C7.13937 2.93465 7.13937 2.55524 7.36901 2.31561C7.59866 2.08596 7.97807 2.08596 8.2177 2.31561L12.4112 6.50913C12.6409 6.73878 12.6409 7.11819 12.4112 7.35782C12.2914 7.47764 12.1317 7.53755 11.9819 7.53755Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.546bfc228bd43920ad7148a08a6ef7c6.svg";
export { ForwardRef as ReactComponent };